import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { to: '/m', label: 'Home', icon: '⊞', end: true },
  { to: '/m/invoices', label: 'Invoices', icon: '🧾' },
  { to: '/m/proformas', label: 'Pro Forma', icon: '📋' },
  { to: '/m/quotations', label: 'Quotations', icon: '📝' },
  { to: '/m/clients', label: 'Clients', icon: '👥' },
];

export default function MobileLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f7', fontFamily: 'Inter, sans-serif' }}>
      {/* Top bar */}
      <div style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'white', borderBottom: '1px solid #eee',
        padding: '12px 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <img src="/travelscape-logo.png" alt="TLS" style={{ height: 32 }}
          onError={e => { e.target.style.display = 'none'; }} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 12, color: '#888' }}>{user?.email?.split('@')[0]}</span>
          <button onClick={handleLogout}
            style={{ fontSize: 12, background: 'none', border: '1px solid #ddd', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', color: '#555' }}>
            Sign out
          </button>
        </div>
      </div>

      {/* Page content */}
      <div style={{ maxWidth: 540, margin: '0 auto' }}>
        <Outlet />
      </div>

      {/* Bottom nav */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 100,
        background: 'white', borderTop: '1px solid #eee',
        display: 'flex', justifyContent: 'space-around', alignItems: 'center',
        padding: '8px 0 12px',
      }}>
        {NAV.map(item => (
          <NavLink key={item.to} to={item.to} end={item.end}
            style={({ isActive }) => ({
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
              textDecoration: 'none', flex: 1,
              color: isActive ? '#f07040' : '#999',
            })}>
            <span style={{ fontSize: 20 }}>{item.icon}</span>
            <span style={{ fontSize: 10, fontWeight: 600 }}>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
}
